import PropTypes from 'prop-types';
import React, { memo } from 'react';

import { COLORS } from 'theme';

import { CardContainer } from './styles';

const CARD_BACKGROUND_COLORS = {
  primary: COLORS.white,
  secondary: COLORS.black02,
};

const Card = ({
  isHighlighted,
  onClick,
  color = 'primary',
  hasError,
  children,
  ...props
}) => (
  <CardContainer
    $isHighlighted={isHighlighted}
    onClick={onClick}
    $isClickable={!!onClick}
    $backgroundColor={CARD_BACKGROUND_COLORS[color]}
    $hasError={hasError}
    {...props}
  >
    {children}
  </CardContainer>
);

Card.propTypes = {
  isHighlighted: PropTypes.bool,
  onClick: PropTypes.func,
  color: PropTypes.oneOf(Object.keys(CARD_BACKGROUND_COLORS)),
  children: PropTypes.node,
  hasError: PropTypes.bool,
};

export default memo(Card);

export { default as CardContent } from './CardContent';
export { default as CardHeader } from './CardHeader';
export { CardSubheader } from './Card.styles';
export { default as CardDataLocation } from './CardDataLocation';
export {
  CardContainer,
  CardDivider,
  CardParagraph,
  CardPaddedRow,
  CardRow,
  CardDoubleColumnRow,
  CardDataRow,
  CardDataIconValueContainer,
  CardDataValue,
  CardDataLabel,
} from './styles';
export { CARD_HEADER_SIZE } from './constants';
